import Cookies from "js-cookie";

const getWorkspaceSessions = async ({ commit, rootGetters, dispatch }, payload) => {
    commit("SET_SESSIONS_LIST_LOADING", true);
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { ...payload, customer_id: customer.customer_id };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        const response = await window.axios.get(`/proxy/ai/workspaces/${data.workspaceId}/sessions?customer_id=${data.customer_id}&userId=${Cookies.get('userId')}`, data);
        if (response && response.data.success) {
            commit('SET_SESSIONS_LIST', response.data.sessions)
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message, { root: true });
    } finally {
        commit("SET_SESSIONS_LIST_LOADING", false);
    }
};

export default getWorkspaceSessions;